import React, { useState } from "react";
import styled from "styled-components";
import Tabs, { Tab } from "@8x8/oxygen-tabs";

import { CustomerCard } from "@/react/features/customer/card";
import RecordingSettingsTable from "./recording-settings/RecordingSettingsTable";
import CallWaitingTable from "./call-waiting/CallWaitingTable";
import ForwardingRulesTable from "./forwarding-rules/ForwardingRulesTable";
import MultiCallSupportTable from "./multi-call-support/MultiCallSupportTable";
import TableWrapper from "@/react/features/styled/TableWrapper";
import PageLayout from "@/react/features/styled/PageLayout";

const TABLES = Object.freeze({
  FORWARDING_RULES: "Forwarding Rules",
  CALL_WAITING: "Call Waiting",
  RECORDING_SETTINGS: "Recording Settings",
  MULTI_CALL_SUPPORT: "Multi Call Support",
});

const StyledTabs = styled(Tabs)`
  margin: 0 0 16px;
`;

const ExtensionsPage = () => {
  const [tableDisplayed, setTableDisplayed] = useState(TABLES.FORWARDING_RULES);

  return (
    <PageLayout>
      <CustomerCard hasPbxSelector={true} />
      <StyledTabs>
        {Object.values(TABLES).map((tableName) => (
          <Tab
            key={tableName}
            color="light"
            onClick={() => setTableDisplayed(tableName)}
            isActive={tableDisplayed === tableName}
          >
            <h6>{tableName}</h6>
          </Tab>
        ))}
      </StyledTabs>
      <TableWrapper>
        {tableDisplayed === TABLES.CALL_WAITING && <CallWaitingTable />}
        {tableDisplayed === TABLES.FORWARDING_RULES && <ForwardingRulesTable />}
        {tableDisplayed === TABLES.RECORDING_SETTINGS && (
          <RecordingSettingsTable />
        )}
        {tableDisplayed === TABLES.MULTI_CALL_SUPPORT && (
          <MultiCallSupportTable />
        )}
      </TableWrapper>
    </PageLayout>
  );
};

export default ExtensionsPage;
